import { useRef } from "react";
import ModalPop from "./ModalPop";

interface ServiceItem {
  title: string;
  description: string;
}

const services: ServiceItem[] = [
  {
    title: "하수구케어",
    description: "하수구 막힘과 역류를\n해결합니다.",
  },
  {
    title: "배관케어",
    description: "배관 막힘과 오염을\n관리합니다.",
  },
  {
    title: "변기케어",
    description: "변기 막힘과 역류를\n해결합니다.",
  },
  {
    title: "싱크대케어",
    description: "싱크대 막힘과 역류를\n해결합니다.",
  },
  {
    title: "배수구케어",
    description: "배수 불량과 악취를\n해결합니다.",
  },
  {
    title: "각종 배관케어",
    description: "다양한 배관 문제를\n신속히 해결합니다.",
  },
  {
    title: "누수관련 문제",
    description: "누수 원인 탐지부터\n보수까지 진행합니다.",
  },
  {
    title: "방수관련 문제",
    description: "누수 예방을 위한\n방수공사를 진행합니다.",
  },
];

const Service = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <div
      id="services"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36 text-center lg:text-left"
    >
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="mx-auto max-w-[1200px] ">
        {/* Heading */}
        <div className="text-center">
          <p className="font-medium text-base lg:text-xl">
            하수·누수·방수 어떤것도 다 상관없이 해결&nbsp;가능합니다
          </p>
          <h2 className="font-medium">원킬케어 제공 서비스 안내</h2>
        </div>

        {/* Card grid */}
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:mt-10 md:grid-cols-4">
          {services.map((service) => (
            <div
              key={service.title}
              data-aos="fade-up"
              className="flex flex-col rounded-2xl bg-[#b8e9ff] p-5"
            >
              <h3 className="gbold tracking-tighter">{service.title}</h3>
              <p className="mt-2 flex-1 whitespace-pre-line text-base leading-tight tracking-tighter text-secondary">
                {service.description}
              </p>
              <div className="mt-4 flex flex-col gap-2 text-white">
                <button
                  type="button"
                  onClick={() =>
                    window.open(
                      "https://blog.naver.com/PostList.naver?blogId=mbc852000&from=postList&categoryNo=6",
                    )
                  }
                  className="w-full rounded-md bg-gradient-to-r to-secondary via-[#3d7af6] from-[#3d7af6] pt-1 text-base transition-colors"
                >
                  작업사례 보러가기
                </button>
                <button
                  type="button"
                  onClick={openfunc}
                  className="w-full rounded-md bg-primary pt-1 text-base transition-colors"
                >
                  견적문의 요청하기
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Service;
